import { notification } from "antd";
import { t } from "i18next";
import msalInstance from "utils/msal";

const getAuthToken = async (): Promise<string | null> => {
  const accounts = msalInstance.getAllAccounts();
  const account = accounts[0];
  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [
        `api://${process.env.REACT_APP_AZURE_AD_CLIENT_ID}/access_as_user`,
      ],
      account,
    });
    if (response) {
      return response.accessToken;
    }
  } catch (e) {
    console.error(e);
    notification.error({ message: t("something_went_wrong") });
    await msalInstance.logoutRedirect({
      account,
      onRedirectNavigate: () => true,
    });
  }
  return null;
};

export default getAuthToken;
